import {configureStore,combineReducers} from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'
import themeSlice from './themeSlice';
import authSlice from './authSlice';
import testSlice from './testSlice';
import testsSlice from './testsSlice';
import settingSlice from './settingSlice';
import passSlice from './passSlice';
import reportsSlice from './reportsSlice';
import templatesSlice from './templatesSlice';
import jobSlice from './jobSlice';


// Combine reducers
const rootReducer = combineReducers({
  theme : themeSlice,
  auth : authSlice,
  test:testSlice,
  tests:testsSlice,
  setting:settingSlice,
  pass:passSlice,
  reports:reportsSlice,
  templates:templatesSlice,
  job:jobSlice
});

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['theme','auth','test','tests','setting','pass','reports','templates','job'], 
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer :persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck:false,
      actionCreatorCheck:false

    })
});

export const persister = persistStore(store);

export default store;